import { SCOPE_LEVELS } from '@src/constants/general-constants'
import ROUTE from '@/src/constants/route-constants.js'
import { TENANT_ROLES } from '@src/constants/user-roles-constants.js'
import { pluralToSingular } from '@/src/utils/generalUtil'

export const rourterList = (leftbarRoutes, isMultipleCampusesAllowed) => {
  let routes = [
    {
      id: ROUTE.NOTICE_BOARD.ID,
      name: ROUTE.NOTICE_BOARD.NAME,
      routesName: [ROUTE.NOTICE_BOARD.VIEW.PATH, ROUTE.NOTICE_BOARD.LABELS.PATH],
      icon: ROUTE.NOTICE_BOARD.ICON,
      showChilds: false,
      role: [
        TENANT_ROLES.SUPER_ADMIN,
        TENANT_ROLES.CAMPUS_ADMIN,
        TENANT_ROLES.SECTION_TEACHER,
        TENANT_ROLES.SECTION_STUDENT,
        TENANT_ROLES.GUARDIAN,
      ],
      basedOn: [SCOPE_LEVELS.CAMPUS_LEVEL],
      childs: [
        {
          id: ROUTE.NOTICE_BOARD.LABELS.ID,
          name: ROUTE.NOTICE_BOARD.LABELS.NAME,
          route: { name: ROUTE.NOTICE_BOARD.LABELS.PATH },
          routesName: [ROUTE.NOTICE_BOARD.LABELS.PATH],
          icon: ROUTE.NOTICE_BOARD.ICON,
          role: [TENANT_ROLES.SUPER_ADMIN],
        },
        {
          id: ROUTE.NOTICE_BOARD.VIEW.ID,
          name: ROUTE.NOTICE_BOARD.VIEW.NAME,
          route: { name: ROUTE.NOTICE_BOARD.VIEW.PATH },
          routesName: [ROUTE.NOTICE_BOARD.VIEW.PATH],
          icon: ROUTE.NOTICE_BOARD.ICON,
          role: [
            TENANT_ROLES.SUPER_ADMIN,
            TENANT_ROLES.CAMPUS_ADMIN,
            TENANT_ROLES.SECTION_TEACHER,
            TENANT_ROLES.SECTION_STUDENT,
            TENANT_ROLES.GUARDIAN,
          ],
        },
      ],
    },
    {
      id: ROUTE.DASHBOARD.ID,
      name: ROUTE.DASHBOARD.NAME,
      route: { name: ROUTE.DASHBOARD.PATH },
      icon: ROUTE.DASHBOARD.ICON,
      role: [TENANT_ROLES.SUPER_ADMIN, TENANT_ROLES.CAMPUS_ADMIN],
    },
    {
      id: ROUTE.QUICK_ACTION.ID,
      name: ROUTE.QUICK_ACTION.NAME,
      route: { name: ROUTE.QUICK_ACTION.PATH },
      routesName: [ROUTE.QUICK_ACTION.PATH],
      icon: ROUTE.QUICK_ACTION.ICON,
      role: [TENANT_ROLES.SUPER_ADMIN, TENANT_ROLES.CAMPUS_ADMIN],
      basedOn: [
        SCOPE_LEVELS.ROOT_LEVEL,
        SCOPE_LEVELS.CAMPUS_LEVEL,
        SCOPE_LEVELS.CLASS_LEVEL,
        SCOPE_LEVELS.SECTION_LEVEL,
      ],
    },
    isMultipleCampusesAllowed && {
      id: ROUTE.CAMPUSES.ID,
      name: ROUTE.CAMPUSES.NAME,
      route: { name: ROUTE.CAMPUSES.PATH },
      icon: ROUTE.CAMPUSES.ICON,
      role: TENANT_ROLES.SUPER_ADMIN,
      basedOn: [SCOPE_LEVELS.ROOT_LEVEL],
    },
    {
      id: ROUTE.ATTENDANCE.ID,
      name: ROUTE.ATTENDANCE.NAME,
      icon: ROUTE.ATTENDANCE.ICON,
      role: [
        TENANT_ROLES.SUPER_ADMIN,
        TENANT_ROLES.SECTION_TEACHER,
        TENANT_ROLES.SECTION_STUDENT,
        TENANT_ROLES.GUARDIAN,
        TENANT_ROLES.CAMPUS_ADMIN,
      ],
      showChilds: false,
      basedOn: [SCOPE_LEVELS.CAMPUS_LEVEL, SCOPE_LEVELS.CLASS_LEVEL, SCOPE_LEVELS.SECTION_LEVEL],
      routesName: [
        ROUTE.ATTENDANCE.CAMPUS.PATH,
        ROUTE.ATTENDANCE.SECTION.PATH,
        ROUTE.ATTENDANCE.SECTION.MARK.PATH,
        ROUTE.ATTENDANCE.DAILY_STUDENT_ATTENDANCE.PATH,
        ROUTE.ATTENDANCE.DAILY_STAFF_ATTENDANCE.PATH,
        ROUTE.ATTENDANCE.PERIOD.PATH,
        ROUTE.ATTENDANCE.STAFF.PATH,
        'students-period-attendance-details',
        'teacherCheckInCheckOut',
        'studentBulkCheckIn',
        'staffCheckInOut',
        'staffBulkCheckIn',
        'staffBulkCheckOut',
        'teacherCheckInOut',
      ],
      childs: [
        {
          id: ROUTE.ATTENDANCE.CAMPUS.ID,
          name: ROUTE.ATTENDANCE.CAMPUS.NAME,
          route: { name: ROUTE.ATTENDANCE.CAMPUS.PATH },
          basedOn: [
            SCOPE_LEVELS.CAMPUS_LEVEL,
            SCOPE_LEVELS.CLASS_LEVEL,
            SCOPE_LEVELS.SECTION_LEVEL,
          ],
        },
        {
          id: ROUTE.ATTENDANCE.SECTION.ID,
          name: ROUTE.ATTENDANCE.SECTION.NAME,
          displayName: `${pluralToSingular(leftbarRoutes.SECTIONS.DISPLAY_NAME)}_ATTENDANCE`,
          route: { name: ROUTE.ATTENDANCE.SECTION.PATH },
          basedOn: [SCOPE_LEVELS.CLASS_LEVEL, SCOPE_LEVELS.SECTION_LEVEL],
        },
        {
          id: ROUTE.ATTENDANCE.SECTION.MARK.ID,
          name: ROUTE.ATTENDANCE.SECTION.MARK.NAME,
          route: { name: ROUTE.ATTENDANCE.SECTION.MARK.PATH },
          isDynamicRoute: true,
          basedOn: [SCOPE_LEVELS.SECTION_LEVEL],
        },
        {
          id: ROUTE.ATTENDANCE.SECTION.DETAIL.ID,
          name: ROUTE.ATTENDANCE.SECTION.DETAIL.NAME,
          route: { name: ROUTE.ATTENDANCE.SECTION.DETAIL.PATH },
          isDynamicRoute: true,
          basedOn: [SCOPE_LEVELS.SECTION_LEVEL],
        },
        {
          id: ROUTE.ATTENDANCE.DAILY_STUDENT_ATTENDANCE.ID,
          name: ROUTE.ATTENDANCE.DAILY_STUDENT_ATTENDANCE.NAME,
          route: { name: ROUTE.ATTENDANCE.DAILY_STUDENT_ATTENDANCE.PATH },
          basedOn: [SCOPE_LEVELS.CAMPUS_LEVEL],
        },
        {
          id: ROUTE.ATTENDANCE.DAILY_STAFF_ATTENDANCE.ID,
          name: ROUTE.ATTENDANCE.DAILY_STAFF_ATTENDANCE.NAME,
          route: { name: ROUTE.ATTENDANCE.DAILY_STAFF_ATTENDANCE.PATH },
          basedOn: [SCOPE_LEVELS.CAMPUS_LEVEL],
        },
        {
          id: ROUTE.ATTENDANCE.PERIOD.ID,
          name: ROUTE.ATTENDANCE.PERIOD.NAME,
          route: { name: ROUTE.ATTENDANCE.PERIOD.PATH },
          basedOn: [SCOPE_LEVELS.SECTION_LEVEL],
        },
        {
          id: ROUTE.ATTENDANCE.STAFF.ID,
          name: ROUTE.ATTENDANCE.STAFF.NAME,
          route: { name: ROUTE.ATTENDANCE.STAFF.PATH },
          basedOn: [SCOPE_LEVELS.CAMPUS_LEVEL],
          role: [TENANT_ROLES.SUPER_ADMIN, TENANT_ROLES.SECTION_TEACHER, TENANT_ROLES.CAMPUS_ADMIN],
        },
      ],
    },
    {
      id: ROUTE.TIME_TABLE.ID,
      name: ROUTE.TIME_TABLE.NAME,
      routesName: [
        ROUTE.TIME_TABLE.AUTOMATOR.PATH,
        ROUTE.TIME_TABLE.CURRENT.PATH,
        ROUTE.TIME_TABLE.MY_TIMETABLE.PATH,
        ROUTE.TIME_TABLE.STAFF_BIRTHDAYS.PATH,
        ROUTE.TIME_TABLE.STUDENT_BIRTHDAYS.PATH,
        ROUTE.TIME_TABLE.LESSON_PLANNER.PATH,
      ],
      icon: ROUTE.TIME_TABLE.ICON,
      basedOn: [SCOPE_LEVELS.CAMPUS_LEVEL, SCOPE_LEVELS.SECTION_LEVEL],

      role: [
        TENANT_ROLES.SUPER_ADMIN,
        TENANT_ROLES.SECTION_TEACHER,
        TENANT_ROLES.SECTION_STUDENT,
        TENANT_ROLES.GUARDIAN,
        TENANT_ROLES.CAMPUS_ADMIN,
      ],
      showChilds: false,

      childs: [
        {
          id: ROUTE.TIME_TABLE.ID,
          name: ROUTE.TIME_TABLE.AUTOMATOR.NAME,
          route: { name: ROUTE.TIME_TABLE.AUTOMATOR.PATH },
          role: [TENANT_ROLES.SUPER_ADMIN, TENANT_ROLES.SECTION_TEACHER, TENANT_ROLES.CAMPUS_ADMIN],
          basedOn: [SCOPE_LEVELS.SECTION_LEVEL],
        },
        {
          id: ROUTE.TIME_TABLE.CURRENT.ID,
          name: ROUTE.TIME_TABLE.CURRENT.NAME,
          route: { name: ROUTE.TIME_TABLE.CURRENT.PATH },
          role: [
            TENANT_ROLES.SUPER_ADMIN,
            TENANT_ROLES.SECTION_TEACHER,
            TENANT_ROLES.SECTION_STUDENT,
            TENANT_ROLES.GUARDIAN,
            TENANT_ROLES.CAMPUS_ADMIN,
          ],
          basedOn: [SCOPE_LEVELS.SECTION_LEVEL],
        },
        {
          id: ROUTE.TIME_TABLE.MY_TIMETABLE.ID,
          name: ROUTE.TIME_TABLE.MY_TIMETABLE.NAME,
          route: { name: ROUTE.TIME_TABLE.MY_TIMETABLE.PATH },
          role: [TENANT_ROLES.SECTION_TEACHER],
          basedOn: [SCOPE_LEVELS.CAMPUS_LEVEL],
        },
        {
          id: ROUTE.TIME_TABLE.STAFF_BIRTHDAYS.ID,
          name: ROUTE.TIME_TABLE.STAFF_BIRTHDAYS.NAME,
          route: { name: ROUTE.TIME_TABLE.STAFF_BIRTHDAYS.PATH },
          role: [TENANT_ROLES.SUPER_ADMIN, TENANT_ROLES.CAMPUS_ADMIN],
          basedOn: [SCOPE_LEVELS.CAMPUS_LEVEL],
        },
        {
          id: ROUTE.TIME_TABLE.STUDENT_BIRTHDAYS.ID,
          name: ROUTE.TIME_TABLE.STUDENT_BIRTHDAYS.NAME,
          route: { name: ROUTE.TIME_TABLE.STUDENT_BIRTHDAYS.PATH },
          role: [TENANT_ROLES.SUPER_ADMIN, TENANT_ROLES.CAMPUS_ADMIN, TENANT_ROLES.SECTION_TEACHER],
          basedOn: [
            SCOPE_LEVELS.CAMPUS_LEVEL,
            SCOPE_LEVELS.CLASS_LEVEL,
            SCOPE_LEVELS.SECTION_LEVEL,
          ],
        },
        {
          id: ROUTE.TIME_TABLE.LESSON_PLANNER.ID,
          name: ROUTE.TIME_TABLE.LESSON_PLANNER.NAME,
          route: { name: ROUTE.TIME_TABLE.LESSON_PLANNER.PATH },
          role: [TENANT_ROLES.SUPER_ADMIN, TENANT_ROLES.SECTION_TEACHER, TENANT_ROLES.CAMPUS_ADMIN],
          basedOn: [SCOPE_LEVELS.SECTION_LEVEL],
        },
      ],
    },
    {
      id: ROUTE.TEACHER_USERS.ID,
      icon: ROUTE.TEACHER_USERS.ICON,
      name: ROUTE.TEACHER_USERS.NAME,
      showChilds: false,
      role: [TENANT_ROLES.SECTION_TEACHER],
      basedOn: [SCOPE_LEVELS.SECTION_LEVEL],
      routesName: [ROUTE.TEACHER_USERS.STUDENT.PATH],
      childs: [
        {
          id: ROUTE.TEACHER_USERS.STUDENT.ID,
          name: ROUTE.TEACHER_USERS.STUDENT.NAME,
          route: { name: ROUTE.TEACHER_USERS.STUDENT.PATH },
        },
      ],
    },
    {
      id: ROUTE.USERS.ID,
      name: ROUTE.USERS.NAME,
      icon: ROUTE.USERS.ICON,
      showChilds: false,
      role: [TENANT_ROLES.SUPER_ADMIN, TENANT_ROLES.CAMPUS_ADMIN],
      basedOn: [
        SCOPE_LEVELS.ROOT_LEVEL,
        SCOPE_LEVELS.CAMPUS_LEVEL,
        SCOPE_LEVELS.CLASS_LEVEL,
        SCOPE_LEVELS.SECTION_LEVEL,
      ],

      routesName: [
        ROUTE.USERS.SUPER_ADMIN.PATH,
        ROUTE.USERS.CAMPUS_ADMIN.PATH,
        ROUTE.USERS.STAFF.PATH,
        ROUTE.USERS.TEACHERS.PATH,
        ROUTE.USERS.STUDENTS.PATH,
        ROUTE.USERS.GUARDIANS.PATH,
        ROUTE.USERS.PICKUP_PERSONS.PATH,
        ROUTE.USERS.ALL_USERS.PATH,
      ],
      childs: [
        {
          id: ROUTE.USERS.SUPER_ADMIN.ID,
          name: ROUTE.USERS.SUPER_ADMIN.NAME,
          route: { name: ROUTE.USERS.SUPER_ADMIN.PATH },
          role: [TENANT_ROLES.SUPER_ADMIN],
        },
        {
          id: ROUTE.USERS.CAMPUS_ADMIN.ID,
          name: ROUTE.USERS.CAMPUS_ADMIN.NAME,
          route: { name: ROUTE.USERS.CAMPUS_ADMIN.PATH },
          role: [TENANT_ROLES.SUPER_ADMIN, TENANT_ROLES.CAMPUS_ADMIN],
        },
        {
          id: ROUTE.USERS.STAFF.ID,
          name: ROUTE.USERS.STAFF.NAME,
          route: { name: ROUTE.USERS.STAFF.PATH },
          role: [TENANT_ROLES.SUPER_ADMIN, TENANT_ROLES.CAMPUS_ADMIN],
        },
        {
          id: ROUTE.USERS.TEACHERS.ID,
          name: ROUTE.USERS.TEACHERS.NAME,
          route: { name: ROUTE.USERS.TEACHERS.PATH },
          role: [TENANT_ROLES.SUPER_ADMIN, TENANT_ROLES.CAMPUS_ADMIN],
        },
        {
          id: ROUTE.USERS.STUDENTS.ID,
          name: ROUTE.USERS.STUDENTS.NAME,
          route: { name: ROUTE.USERS.STUDENTS.PATH },
          role: [TENANT_ROLES.SUPER_ADMIN, TENANT_ROLES.CAMPUS_ADMIN, TENANT_ROLES.SECTION_TEACHER],
          routesName: ['students-roles-and-acccess-management'],
        },
        {
          id: ROUTE.USERS.GUARDIANS.ID,
          name: ROUTE.USERS.GUARDIANS.NAME,
          route: { name: ROUTE.USERS.GUARDIANS.PATH },
          role: [TENANT_ROLES.SUPER_ADMIN, TENANT_ROLES.CAMPUS_ADMIN],
        },
        {
          id: ROUTE.USERS.PICKUP_PERSONS.ID,
          name: ROUTE.USERS.PICKUP_PERSONS.NAME,
          route: { name: ROUTE.USERS.PICKUP_PERSONS.PATH },
          role: [TENANT_ROLES.SUPER_ADMIN, TENANT_ROLES.CAMPUS_ADMIN],
        },
        {
          id: ROUTE.USERS.ALL_USERS.ID,
          name: ROUTE.USERS.ALL_USERS.NAME,
          route: { name: ROUTE.USERS.ALL_USERS.PATH },
          role: [TENANT_ROLES.SUPER_ADMIN, TENANT_ROLES.CAMPUS_ADMIN],
        },
      ],
    },
    {
      id: ROUTE.CLASSES.ID,
      displayName: leftbarRoutes.CLASSES.DISPLAY_NAME,
      name: ROUTE.CLASSES.DISPLAY_NAME,
      route: { name: ROUTE.CLASSES.PATH },
      icon: ROUTE.CLASSES.ICON,
      role: [TENANT_ROLES.SUPER_ADMIN, TENANT_ROLES.CAMPUS_ADMIN],
      basedOn: [SCOPE_LEVELS.CAMPUS_LEVEL, SCOPE_LEVELS.ROOT_LEVEL],
    },
    {
      id: ROUTE.ROOMS.ID,
      name: ROUTE.ROOMS.NAME,
      route: { name: ROUTE.ROOMS.PATH },
      icon: ROUTE.ROOMS.ICON,
      role: [TENANT_ROLES.SUPER_ADMIN, TENANT_ROLES.CAMPUS_ADMIN],
      basedOn: [SCOPE_LEVELS.CAMPUS_LEVEL],
    },
    {
      id: ROUTE.SECTIONS.ID,
      name: ROUTE.SECTIONS.NAME,
      displayName: leftbarRoutes.SECTIONS.DISPLAY_NAME,
      route: { name: ROUTE.SECTIONS.PATH },
      icon: ROUTE.SECTIONS.ICON,
      role: [TENANT_ROLES.SUPER_ADMIN, TENANT_ROLES.CAMPUS_ADMIN],
      basedOn: [SCOPE_LEVELS.CAMPUS_LEVEL, SCOPE_LEVELS.CLASS_LEVEL],
    },
    {
      id: ROUTE.SALARIES.ID,
      name: ROUTE.SALARIES.NAME,
      route: { name: ROUTE.SALARIES.PATH },
      icon: ROUTE.SALARIES.ICON,
      role: TENANT_ROLES.SUPER_ADMIN,
      basedOn: [SCOPE_LEVELS.SECTION_LEVEL],
    },
    {
      id: ROUTE.LESSON_TYPES.ID,
      name: ROUTE.LESSON_TYPES.NAME,
      route: { name: ROUTE.LESSON_TYPES.PATH },
      icon: ROUTE.LESSON_TYPES.ICON,
      basedOn: [SCOPE_LEVELS.ROOT_LEVEL],
      role: [TENANT_ROLES.SUPER_ADMIN, TENANT_ROLES.CAMPUS_ADMIN],
    },
    {
      id: ROUTE.SYLLABUS_MANAGER.ID,
      icon: ROUTE.SYLLABUS_MANAGER.ICON,
      name: ROUTE.SYLLABUS_MANAGER.NAME,
      role: [
        TENANT_ROLES.SUPER_ADMIN,
        TENANT_ROLES.SECTION_TEACHER,
        TENANT_ROLES.SECTION_STUDENT,
        TENANT_ROLES.GUARDIAN,
        TENANT_ROLES.CAMPUS_ADMIN,
      ],
      basedOn: [SCOPE_LEVELS.CLASS_LEVEL, SCOPE_LEVELS.SECTION_LEVEL],
      route: { name: ROUTE.SYLLABUS_MANAGER.PATH },
      showChilds: false,
      routesName: [
        ROUTE.SYLLABUS_MANAGER.SYLLABUS_TEMPLATE_PROVIDER.PATH,
        ROUTE.SYLLABUS_MANAGER.SUBJECT_SYLLABUS_TEMPLATE.PATH,
        ROUTE.SYLLABUS_MANAGER.DETAIL_VIEW.PATH,
        ROUTE.SYLLABUS_MANAGER.DETAIL_VIEW.PATH,
        ROUTE.SYLLABUS_MANAGER.IMPORT_CLONE.PATH,
        ROUTE.SYLLABUS_MANAGER.SUBJECTS.PATH,
        ROUTE.SYLLABUS_MANAGER.CHAPTERS.PATH,
        ROUTE.SYLLABUS_MANAGER.TOPICS.PATH,
        ROUTE.SYLLABUS_MANAGER.LESSONS.PATH,
      ],
      childs: [
        {
          id: ROUTE.SYLLABUS_MANAGER.SYLLABUS_TEMPLATE_PROVIDER.ID,
          name: ROUTE.SYLLABUS_MANAGER.SYLLABUS_TEMPLATE_PROVIDER.NAME,
          basedOn: [SCOPE_LEVELS.CAMPUS_LEVEL],
          role: [TENANT_ROLES.SUPER_ADMIN, TENANT_ROLES.CAMPUS_ADMIN, TENANT_ROLES.SECTION_TEACHER],
          route: { name: ROUTE.SYLLABUS_MANAGER.SYLLABUS_TEMPLATE_PROVIDER.PATH },
        },
        {
          id: ROUTE.SYLLABUS_MANAGER.SUBJECT_SYLLABUS_TEMPLATE.ID,
          name: ROUTE.SYLLABUS_MANAGER.SUBJECT_SYLLABUS_TEMPLATE.NAME,
          basedOn: [SCOPE_LEVELS.CAMPUS_LEVEL],
          role: [TENANT_ROLES.SUPER_ADMIN, TENANT_ROLES.CAMPUS_ADMIN, TENANT_ROLES.SECTION_TEACHER],

          route: { name: ROUTE.SYLLABUS_MANAGER.SUBJECT_SYLLABUS_TEMPLATE.PATH },
        },
        {
          id: ROUTE.SYLLABUS_MANAGER.DETAIL_VIEW.ID,
          name: ROUTE.SYLLABUS_MANAGER.DETAIL_VIEW.NAME,
          basedOn: [SCOPE_LEVELS.CAMPUS_LEVEL],
          route: { name: ROUTE.SYLLABUS_MANAGER.DETAIL_VIEW.PATH },
          isDynamicRoute: true,
        },
        {
          id: ROUTE.SYLLABUS_MANAGER.IMPORT_CLONE.ID,
          name: ROUTE.SYLLABUS_MANAGER.IMPORT_CLONE.NAME,
          isDynamicRoute: true,
          basedOn: [SCOPE_LEVELS.CAMPUS_LEVEL],
          route: { name: ROUTE.SYLLABUS_MANAGER.IMPORT_CLONE.PATH },
        },

        {
          id: ROUTE.SYLLABUS_MANAGER.SUBJECTS.ID,
          name: ROUTE.SYLLABUS_MANAGER.SUBJECTS.NAME,
          route: { name: ROUTE.SYLLABUS_MANAGER.SUBJECTS.PATH },
          isMandatory: true,
        },
        {
          id: ROUTE.SYLLABUS_MANAGER.CHAPTERS.ID,
          name: ROUTE.SYLLABUS_MANAGER.CHAPTERS.NAME,
          route: { name: ROUTE.SYLLABUS_MANAGER.CHAPTERS.PATH },
        },
        {
          id: ROUTE.SYLLABUS_MANAGER.TOPICS.ID,
          name: ROUTE.SYLLABUS_MANAGER.TOPICS.NAME,
          route: { name: ROUTE.SYLLABUS_MANAGER.TOPICS.PATH },
        },
        {
          id: ROUTE.SYLLABUS_MANAGER.LESSONS.ID,
          name: ROUTE.SYLLABUS_MANAGER.LESSONS.NAME,
          route: { name: ROUTE.SYLLABUS_MANAGER.LESSONS.PATH },
        },
      ],
    },
    {
      id: ROUTE.ASSIGNMENT.ID,
      icon: ROUTE.ASSIGNMENT.ICON,
      name: ROUTE.ASSIGNMENT.NAME,
      role: [
        TENANT_ROLES.SUPER_ADMIN,
        TENANT_ROLES.CAMPUS_ADMIN,
        TENANT_ROLES.SECTION_TEACHER,
        TENANT_ROLES.GUARDIAN,
        TENANT_ROLES.SECTION_STUDENT,
      ],
      basedOn: [SCOPE_LEVELS.CLASS_LEVEL, SCOPE_LEVELS.SECTION_LEVEL],
      route: { name: ROUTE.ASSIGNMENT.PATH },
      showChilds: false,
      routesName: [
        ROUTE.ASSIGNMENT.ASSIGNMENT_TYPES.PATH,
        ROUTE.ASSIGNMENT.ASSIGNMENTS.PATH,
        ROUTE.ASSIGNMENT.ASSIGNMENTS_DETAILS.PATH,
      ],
      childs: [
        {
          id: ROUTE.ASSIGNMENT.ASSIGNMENT_TYPES.ID,
          name: ROUTE.ASSIGNMENT.ASSIGNMENT_TYPES.NAME,
          route: { name: ROUTE.ASSIGNMENT.ASSIGNMENT_TYPES.PATH },
          basedOn: [SCOPE_LEVELS.CLASS_LEVEL, SCOPE_LEVELS.SECTION_LEVEL],
          role: [TENANT_ROLES.SUPER_ADMIN, TENANT_ROLES.SECTION_TEACHER, TENANT_ROLES.CAMPUS_ADMIN],
        },
        {
          id: ROUTE.ASSIGNMENT.ASSIGNMENTS.ID,
          name: ROUTE.ASSIGNMENT.ASSIGNMENTS.NAME,
          route: { name: ROUTE.ASSIGNMENT.ASSIGNMENTS.PATH },
          basedOn: [SCOPE_LEVELS.CLASS_LEVEL, SCOPE_LEVELS.SECTION_LEVEL],
        },
        {
          id: ROUTE.ASSIGNMENT.ASSIGNMENTS_DETAILS.ID,
          name: ROUTE.ASSIGNMENT.ASSIGNMENTS_DETAILS.NAME,
          route: { name: ROUTE.ASSIGNMENT.ASSIGNMENTS_DETAILS.PATH },
          basedOn: [SCOPE_LEVELS.CLASS_LEVEL, SCOPE_LEVELS.SECTION_LEVEL],
          isDynamicRoute: true,
        },
      ],
    },

    {
      id: ROUTE.FEE_MANAGER.ID,
      name: ROUTE.FEE_MANAGER.NAME,
      icon: ROUTE.FEE_MANAGER.ICON,
      role: [
        TENANT_ROLES.SUPER_ADMIN,
        TENANT_ROLES.SECTION_TEACHER,
        TENANT_ROLES.SECTION_STUDENT,
        TENANT_ROLES.GUARDIAN,
        TENANT_ROLES.CAMPUS_ADMIN,
      ],
      basedOn: [SCOPE_LEVELS.CAMPUS_LEVEL, SCOPE_LEVELS.SECTION_LEVEL, SCOPE_LEVELS.CLASS_LEVEL],
      route: { name: ROUTE.FEE_MANAGER.RECEIVABLE.PATH },
      showChilds: false,
      routesName: [
        ROUTE.FEE_MANAGER.FEE_TYPES.PATH,
        ROUTE.FEE_MANAGER.PAYABLE.PATH,
        ROUTE.FEE_MANAGER.RECEIVABLE.PATH,
        ROUTE.FEE_MANAGER.PAID.PATH,
        ROUTE.FEE_MANAGER.RECEIVED.PATH,
        ROUTE.FEE_MANAGER.ACCEPT_PAYMENT.PATH,
        ROUTE.FEE_MANAGER.SECTION_FEE.PATH,
        ROUTE.FEE_MANAGER.MONTHLY_FEE_GENERATOR.PATH,
        ROUTE.FEE_MANAGER.DISCOUNT_TYPES.PATH,
        ROUTE.FEE_MANAGER.STUDENT_DISCOUNT_LIST.PATH,
        ROUTE.FEE_MANAGER.STUDENT_DISCOUNT_DETAIL.PATH,
      ],
      childs: [
        {
          id: ROUTE.FEE_MANAGER.FEE_TYPES.ID,
          name: ROUTE.FEE_MANAGER.FEE_TYPES.NAME,
          route: { name: ROUTE.FEE_MANAGER.FEE_TYPES.PATH },
          role: [TENANT_ROLES.SUPER_ADMIN, TENANT_ROLES.CAMPUS_ADMIN],
        },
        {
          id: ROUTE.FEE_MANAGER.PAYABLE.ID,
          name: ROUTE.FEE_MANAGER.PAYABLE.NAME,
          route: { name: ROUTE.FEE_MANAGER.PAYABLE.PATH },
          role: [TENANT_ROLES.SECTION_STUDENT, TENANT_ROLES.GUARDIAN],
        },
        {
          id: ROUTE.FEE_MANAGER.RECEIVABLE.ID,
          name: ROUTE.FEE_MANAGER.RECEIVABLE.NAME,
          route: { name: ROUTE.FEE_MANAGER.RECEIVABLE.PATH },
          role: [TENANT_ROLES.SUPER_ADMIN, TENANT_ROLES.SECTION_TEACHER, TENANT_ROLES.CAMPUS_ADMIN],
        },

        {
          id: ROUTE.FEE_MANAGER.PAID.ID,
          name: ROUTE.FEE_MANAGER.PAID.NAME,
          route: { name: ROUTE.FEE_MANAGER.PAID.PATH },
          role: [TENANT_ROLES.SECTION_STUDENT, TENANT_ROLES.GUARDIAN],
        },
        {
          id: ROUTE.FEE_MANAGER.RECEIVED.ID,
          name: ROUTE.FEE_MANAGER.RECEIVED.NAME,
          route: { name: ROUTE.FEE_MANAGER.RECEIVED.PATH },
          role: [TENANT_ROLES.SUPER_ADMIN, TENANT_ROLES.SECTION_TEACHER, TENANT_ROLES.CAMPUS_ADMIN],
        },
        {
          id: ROUTE.FEE_MANAGER.ACCEPT_PAYMENT.ID,
          name: ROUTE.FEE_MANAGER.ACCEPT_PAYMENT.NAME,
          route: { name: ROUTE.FEE_MANAGER.ACCEPT_PAYMENT.PATH },
          role: [TENANT_ROLES.SUPER_ADMIN, TENANT_ROLES.CAMPUS_ADMIN],
        },
        {
          id: ROUTE.FEE_MANAGER.SECTION_FEE.ID,
          name: ROUTE.FEE_MANAGER.SECTION_FEE.NAME,
          displayName: `${pluralToSingular(leftbarRoutes.SECTIONS.DISPLAY_NAME)}_FEE`,
          route: { name: ROUTE.FEE_MANAGER.SECTION_FEE.PATH },
          role: [TENANT_ROLES.SUPER_ADMIN, TENANT_ROLES.SECTION_TEACHER, TENANT_ROLES.CAMPUS_ADMIN],
        },
        {
          id: ROUTE.FEE_MANAGER.MONTHLY_FEE_GENERATOR.ID,
          name: ROUTE.FEE_MANAGER.MONTHLY_FEE_GENERATOR.NAME,
          route: { name: ROUTE.FEE_MANAGER.MONTHLY_FEE_GENERATOR.PATH },
          role: [TENANT_ROLES.SUPER_ADMIN, TENANT_ROLES.CAMPUS_ADMIN, TENANT_ROLES.SECTION_TEACHER],
        },

        {
          id: ROUTE.FEE_MANAGER.DISCOUNT_TYPES.ID,
          name: ROUTE.FEE_MANAGER.DISCOUNT_TYPES.NAME,
          route: { name: ROUTE.FEE_MANAGER.DISCOUNT_TYPES.PATH },
          role: [TENANT_ROLES.SUPER_ADMIN, TENANT_ROLES.CAMPUS_ADMIN],
        },
        {
          id: ROUTE.FEE_MANAGER.STUDENT_DISCOUNT_LIST.ID,
          name: ROUTE.FEE_MANAGER.STUDENT_DISCOUNT_LIST.NAME,
          route: { name: ROUTE.FEE_MANAGER.STUDENT_DISCOUNT_LIST.PATH },
          role: [TENANT_ROLES.SUPER_ADMIN, TENANT_ROLES.CAMPUS_ADMIN, TENANT_ROLES.SECTION_TEACHER],
        },
        {
          id: ROUTE.FEE_MANAGER.STUDENT_DISCOUNT_DETAIL.ID,
          name: ROUTE.FEE_MANAGER.STUDENT_DISCOUNT_DETAIL.NAME,
          route: { name: ROUTE.FEE_MANAGER.STUDENT_DISCOUNT_DETAIL.PATH },
          isDynamicRoute: true,
        },
      ],
    },
    {
      id: ROUTE.EXPENSE_MANAGER.ID,
      name: ROUTE.EXPENSE_MANAGER.NAME,
      icon: ROUTE.EXPENSE_MANAGER.ICON,
      role: [TENANT_ROLES.SUPER_ADMIN, TENANT_ROLES.CAMPUS_ADMIN],
      basedOn: [SCOPE_LEVELS.ROOT_LEVEL, SCOPE_LEVELS.CAMPUS_LEVEL],
      route: { name: ROUTE.EXPENSE_MANAGER.EXPENSES.PATH },
      showChilds: false,
      routesName: [
        ROUTE.EXPENSE_MANAGER.EXPENSES.PATH,
        ROUTE.EXPENSE_MANAGER.EXPENSE_CATEGORIES.PATH,
      ],
      childs: [
        {
          id: ROUTE.EXPENSE_MANAGER.EXPENSE_CATEGORIES.ID,
          name: ROUTE.EXPENSE_MANAGER.EXPENSE_CATEGORIES.NAME,
          route: { name: ROUTE.EXPENSE_MANAGER.EXPENSE_CATEGORIES.PATH },
        },
        {
          id: ROUTE.EXPENSE_MANAGER.EXPENSES.ID,
          name: ROUTE.EXPENSE_MANAGER.EXPENSES.NAME,
          route: { name: ROUTE.EXPENSE_MANAGER.EXPENSES.PATH },
          role: [TENANT_ROLES.SUPER_ADMIN],
        },
      ],
    },
    {
      id: ROUTE.EXAMS_MANAGER.ID,
      icon: ROUTE.EXAMS_MANAGER.ICON,
      name: ROUTE.EXAMS_MANAGER.NAME,
      role: [TENANT_ROLES.SUPER_ADMIN, TENANT_ROLES.CAMPUS_ADMIN, TENANT_ROLES.SECTION_TEACHER],
      route: { name: ROUTE.EXAMS_MANAGER.EXAM.PATH },
      basedOn: [SCOPE_LEVELS.SECTION_LEVEL, SCOPE_LEVELS.CLASS_LEVEL],
      showChilds: false,
      routesName: [
        ROUTE.EXAMS_MANAGER.EXAM_TYPES.PATH,
        ROUTE.EXAMS_MANAGER.EXAM.PATH,
        ROUTE.EXAMS_MANAGER.EXAM_DETAILS.PATH,
        ROUTE.EXAMS_MANAGER.EXAM_RESULT_VIEW.PATH,
      ],
      childs: [
        {
          id: ROUTE.EXAMS_MANAGER.EXAM_TYPES.ID,
          name: ROUTE.EXAMS_MANAGER.EXAM_TYPES.NAME,
          route: { name: ROUTE.EXAMS_MANAGER.EXAM_TYPES.PATH },
        },
        {
          id: ROUTE.EXAMS_MANAGER.EXAM.ID,
          name: ROUTE.EXAMS_MANAGER.EXAM.NAME,
          route: { name: ROUTE.EXAMS_MANAGER.EXAM.PATH },
        },
        {
          id: ROUTE.EXAMS_MANAGER.EXAM_DETAILS.ID,
          name: ROUTE.EXAMS_MANAGER.EXAM_DETAILS.NAME,
          route: { name: ROUTE.EXAMS_MANAGER.EXAM_DETAILS.PATH },
          isDynamicRoute: true,
        },
        {
          id: ROUTE.EXAMS_MANAGER.EXAM_RESULT_VIEW.ID,
          name: ROUTE.EXAMS_MANAGER.EXAM_RESULT_VIEW.NAME,
          route: { name: ROUTE.EXAMS_MANAGER.EXAM_RESULT_VIEW.PATH },
          isDynamicRoute: true,
        },
      ],
    },

    //routes for student and guardian
    {
      id: ROUTE.EXAMS.ID,
      icon: ROUTE.EXAMS.ICON,
      name: ROUTE.EXAMS.NAME,
      role: [TENANT_ROLES.SECTION_STUDENT, TENANT_ROLES.GUARDIAN],
      route: { name: ROUTE.EXAMS.EXAM.PATH },
      basedOn: [SCOPE_LEVELS.SECTION_LEVEL, SCOPE_LEVELS.CLASS_LEVEL],
      showChilds: false,
      routesName: [
        ROUTE.EXAMS.EXAM.PATH,
        ROUTE.EXAMS.EXAM_DETAILS.PATH,
        ROUTE.EXAMS.EXAMS_RESULT_VIEW.PATH,
        ROUTE.EXAMS.SUBJECT_RESULT.PATH,
        ROUTE.EXAMS.SUBJECTS_RESULT_DETAIL.PATH,
        ROUTE.EXAMS.SUBJECT_RESULT_VIEW.PATH,
        ROUTE.EXAMS.FINAL_RESULT.PATH,
        ROUTE.EXAMS.STUDENT_PERFORMANCE.PATH,
        ROUTE.EXAMS.FINAL_EXAMS_RESULT_DETAIL.PATH,
        ROUTE.EXAMS.STUDENT_RESULT_DETAIL.PATH,
      ],
      childs: [
        {
          id: ROUTE.EXAMS.EXAM.ID,
          name: ROUTE.EXAMS.EXAM.NAME,
          route: { name: ROUTE.EXAMS.EXAM.PATH },
        },
        {
          id: ROUTE.EXAMS.EXAM_DETAILS.ID,
          name: ROUTE.EXAMS.EXAM_DETAILS.NAME,
          route: { name: ROUTE.EXAMS.EXAM_DETAILS.PATH },
          isDynamicRoute: true,
        },
        {
          id: ROUTE.EXAMS.EXAMS_RESULT_VIEW.ID,
          name: ROUTE.EXAMS.EXAMS_RESULT_VIEW.NAME,
          route: { name: ROUTE.EXAMS.EXAMS_RESULT_VIEW.PATH },
          isDynamicRoute: true,
        },
        {
          id: ROUTE.EXAMS.SUBJECT_RESULT.ID,
          name: ROUTE.EXAMS.SUBJECT_RESULT.NAME,
          route: { name: ROUTE.EXAMS.SUBJECT_RESULT.PATH },
        },
        {
          id: ROUTE.EXAMS.SUBJECTS_RESULT_DETAIL.ID,
          name: ROUTE.EXAMS.SUBJECTS_RESULT_DETAIL.NAME,
          route: { name: ROUTE.EXAMS.SUBJECTS_RESULT_DETAIL.PATH },
          isDynamicRoute: true,
        },
        {
          id: ROUTE.EXAMS.SUBJECT_RESULT_VIEW.ID,
          name: ROUTE.EXAMS.SUBJECT_RESULT_VIEW.NAME,
          route: { name: ROUTE.EXAMS.SUBJECT_RESULT_VIEW.PATH },
          isDynamicRoute: true,
        },
        {
          id: ROUTE.EXAMS.FINAL_RESULT.ID,
          name: ROUTE.EXAMS.FINAL_RESULT.NAME,
          route: { name: ROUTE.EXAMS.FINAL_RESULT.PATH },
        },
        {
          id: ROUTE.EXAMS.STUDENT_PERFORMANCE.ID,
          name: ROUTE.EXAMS.STUDENT_PERFORMANCE.NAME,
          route: { name: ROUTE.EXAMS.STUDENT_PERFORMANCE.PATH },
        },
        {
          id: ROUTE.EXAMS.FINAL_EXAMS_RESULT_DETAIL.ID,
          name: ROUTE.EXAMS.FINAL_EXAMS_RESULT_DETAIL.NAME,
          route: { name: ROUTE.EXAMS.FINAL_EXAMS_RESULT_DETAIL.PATH },
          isDynamicRoute: true,
        },
        {
          id: ROUTE.EXAMS.STUDENT_RESULT_DETAIL.ID,
          name: ROUTE.EXAMS.STUDENT_RESULT_DETAIL.NAME,
          route: { name: ROUTE.EXAMS.STUDENT_RESULT_DETAIL.PATH },
          isDynamicRoute: true,
        },
      ],
    },
    {
      id: ROUTE.GRADES_MANAGER.ID,
      icon: ROUTE.GRADES_MANAGER.ICON,
      name: ROUTE.GRADES_MANAGER.NAME,
      role: [TENANT_ROLES.SUPER_ADMIN, TENANT_ROLES.CAMPUS_ADMIN, TENANT_ROLES.SECTION_TEACHER],
      route: { name: ROUTE.GRADES_MANAGER.SUBJECT_RESULT.PATH },
      basedOn: [SCOPE_LEVELS.SECTION_LEVEL, SCOPE_LEVELS.CLASS_LEVEL],
      showChilds: false,
      routesName: [
        ROUTE.GRADES_MANAGER.NON_GPA_GRADE.PATH,
        ROUTE.GRADES_MANAGER.NON_GPA_GRADE_DETAIL.PATH,
        ROUTE.GRADES_MANAGER.GPA_GRADE.PATH,
        ROUTE.GRADES_MANAGER.GPA_GRADE_DETAIL.PATH,
        ROUTE.GRADES_MANAGER.SUBJECT_RESULT.PATH,
        ROUTE.GRADES_MANAGER.SUBJECT_RESULT_DETAIL.PATH,
        ROUTE.GRADES_MANAGER.SUBJECT_RESULT_VIEW.PATH,
        ROUTE.GRADES_MANAGER.SECTION_EXAMS_RESULT.PATH,
        ROUTE.GRADES_MANAGER.SECTION_EXAMS_RESULT_DETAIL.PATH,
        ROUTE.GRADES_MANAGER.STUDENT_RESULT_DETAIL.PATH,
        ROUTE.GRADES_MANAGER.SECTION_RESULT_VIEW.PATH,
      ],
      childs: [
        {
          id: ROUTE.GRADES_MANAGER.NON_GPA_GRADE.ID,
          name: ROUTE.GRADES_MANAGER.NON_GPA_GRADE.NAME,
          route: { name: ROUTE.GRADES_MANAGER.NON_GPA_GRADE.PATH },
          basedOn: [
            SCOPE_LEVELS.CAMPUS_LEVEL,
            SCOPE_LEVELS.CLASS_LEVEL,
            SCOPE_LEVELS.SECTION_LEVEL,
          ],
        },
        {
          id: ROUTE.GRADES_MANAGER.NON_GPA_GRADE_DETAIL.ID,
          name: ROUTE.GRADES_MANAGER.NON_GPA_GRADE_DETAIL.NAME,
          route: { name: ROUTE.GRADES_MANAGER.NON_GPA_GRADE_DETAIL.PATH },
          isDynamicRoute: true,
        },
        {
          id: ROUTE.GRADES_MANAGER.GPA_GRADE.ID,
          name: ROUTE.GRADES_MANAGER.GPA_GRADE.NAME,
          route: { name: ROUTE.GRADES_MANAGER.GPA_GRADE.PATH },
        },
        {
          id: ROUTE.GRADES_MANAGER.GPA_GRADE_DETAIL.ID,
          name: ROUTE.GRADES_MANAGER.GPA_GRADE_DETAIL.NAME,
          route: { name: ROUTE.GRADES_MANAGER.GPA_GRADE_DETAIL.PATH },
          isDynamicRoute: true,
        },

        {
          id: ROUTE.GRADES_MANAGER.SUBJECT_RESULT.ID,
          name: ROUTE.GRADES_MANAGER.SUBJECT_RESULT.NAME,
          route: { name: ROUTE.GRADES_MANAGER.SUBJECT_RESULT.PATH },
        },
        {
          id: ROUTE.GRADES_MANAGER.SUBJECT_RESULT_DETAIL.ID,
          name: ROUTE.GRADES_MANAGER.SUBJECT_RESULT_DETAIL.NAME,
          route: { name: ROUTE.GRADES_MANAGER.SUBJECT_RESULT_DETAIL.PATH },
          isDynamicRoute: true,
        },
        {
          id: ROUTE.GRADES_MANAGER.SUBJECT_RESULT_VIEW.ID,
          name: ROUTE.GRADES_MANAGER.SUBJECT_RESULT_VIEW.NAME,
          route: { name: ROUTE.GRADES_MANAGER.SUBJECT_RESULT_VIEW.PATH },
          isDynamicRoute: true,
        },
        {
          id: ROUTE.GRADES_MANAGER.SECTION_EXAMS_RESULT.ID,
          name: ROUTE.GRADES_MANAGER.SECTION_EXAMS_RESULT.NAME,
          route: { name: ROUTE.GRADES_MANAGER.SECTION_EXAMS_RESULT.PATH },
        },
        {
          id: ROUTE.GRADES_MANAGER.SECTION_EXAMS_RESULT_DETAIL.ID,
          name: ROUTE.GRADES_MANAGER.SECTION_EXAMS_RESULT_DETAIL.NAME,
          route: { name: ROUTE.GRADES_MANAGER.SECTION_EXAMS_RESULT_DETAIL.PATH },
          isDynamicRoute: true,
        },
        {
          id: ROUTE.GRADES_MANAGER.STUDENT_RESULT_DETAIL.ID,
          name: ROUTE.GRADES_MANAGER.STUDENT_RESULT_DETAIL.NAME,
          route: { name: ROUTE.GRADES_MANAGER.STUDENT_RESULT_DETAIL.PATH },
          isDynamicRoute: true,
        },
        {
          id: ROUTE.GRADES_MANAGER.SECTION_RESULT_VIEW.ID,
          name: ROUTE.GRADES_MANAGER.SECTION_RESULT_VIEW.NAME,
          route: { name: ROUTE.GRADES_MANAGER.SECTION_RESULT_VIEW.PATH },
          isDynamicRoute: true,
        },
      ],
    },
    {
      id: ROUTE.SALARY_MANAGER.ID,
      icon: ROUTE.SALARY_MANAGER.ICON,
      name: ROUTE.SALARY_MANAGER.NAME,
      role: [TENANT_ROLES.SUPER_ADMIN, TENANT_ROLES.CAMPUS_ADMIN, TENANT_ROLES.CAMPUS_ADMIN],
      basedOn: [SCOPE_LEVELS.CAMPUS_LEVEL],
      showChilds: false,
      routesName: [
        ROUTE.SALARY_MANAGER.SALARIES.PATH,
        ROUTE.SALARY_MANAGER.ALLOWANCE_TYPE.PATH,
        ROUTE.SALARY_MANAGER.DEDUCTION_TYPE.PATH,
        ROUTE.SALARY_MANAGER.BONUSES_TYPE.PATH,
        ROUTE.SALARY_MANAGER.EXTRA_WORKING_UNIT.PATH,
        ROUTE.SALARY_MANAGER.SALARY_GENERATOR.PATH,
        ROUTE.SALARY_MANAGER.SALARY_TEMPLATE.PATH,
      ],
      childs: [
        {
          id: ROUTE.SALARY_MANAGER.SALARIES.ID,
          name: ROUTE.SALARY_MANAGER.SALARIES.NAME,
          route: { name: ROUTE.SALARY_MANAGER.SALARIES.PATH },
        },
        {
          id: ROUTE.SALARY_MANAGER.ALLOWANCE_TYPE.ID,
          name: ROUTE.SALARY_MANAGER.ALLOWANCE_TYPE.NAME,
          route: { name: ROUTE.SALARY_MANAGER.ALLOWANCE_TYPE.PATH },
        },
        {
          id: ROUTE.SALARY_MANAGER.DEDUCTION_TYPE.ID,
          name: ROUTE.SALARY_MANAGER.DEDUCTION_TYPE.NAME,
          route: { name: ROUTE.SALARY_MANAGER.DEDUCTION_TYPE.PATH },
        },
        {
          id: ROUTE.SALARY_MANAGER.BONUSES_TYPE.ID,
          name: ROUTE.SALARY_MANAGER.BONUSES_TYPE.NAME,
          route: { name: ROUTE.SALARY_MANAGER.BONUSES_TYPE.PATH },
        },
        {
          id: ROUTE.SALARY_MANAGER.EXTRA_WORKING_UNIT.ID,
          name: ROUTE.SALARY_MANAGER.EXTRA_WORKING_UNIT.NAME,
          route: { name: ROUTE.SALARY_MANAGER.EXTRA_WORKING_UNIT.PATH },
        },
        {
          id: ROUTE.SALARY_MANAGER.SALARY_GENERATOR.ID,
          name: ROUTE.SALARY_MANAGER.SALARY_GENERATOR.NAME,
          route: { name: ROUTE.SALARY_MANAGER.SALARY_GENERATOR.PATH },
        },
        {
          id: ROUTE.SALARY_MANAGER.SALARY_TEMPLATE.ID,
          name: ROUTE.SALARY_MANAGER.SALARY_TEMPLATE.NAME,
          route: { name: ROUTE.SALARY_MANAGER.SALARY_TEMPLATE.PATH },
          isDynamicRoute: true,
        },
      ],
    },
    {
      id: ROUTE.PICKUP_REQUEST_MANAGER.ID,
      name: ROUTE.PICKUP_REQUEST_MANAGER.NAME,
      icon: ROUTE.PICKUP_REQUEST_MANAGER.ICON,
      role: [
        TENANT_ROLES.SUPER_ADMIN,
        TENANT_ROLES.CAMPUS_ADMIN,
        TENANT_ROLES.SECTION_TEACHER,
        TENANT_ROLES.GUARDIAN,
        TENANT_ROLES.PICKUP_PERSON,
      ],
      basedOn: [SCOPE_LEVELS.CAMPUS_LEVEL],
      showChilds: false,
      routesName: [
        ROUTE.PICKUP_REQUEST_MANAGER.FACILITY_ACTIVE_REQUESTS.PATH,
        ROUTE.PICKUP_REQUEST_MANAGER.FACILITY_ALL_REQUESTS.PATH,
      ],
      childs: [
        {
          id: ROUTE.PICKUP_REQUEST_MANAGER.FACILITY_ACTIVE_REQUESTS.ID,
          name: ROUTE.PICKUP_REQUEST_MANAGER.FACILITY_ACTIVE_REQUESTS.NAME,
          route: { name: ROUTE.PICKUP_REQUEST_MANAGER.FACILITY_ACTIVE_REQUESTS.PATH },
          role: [
            TENANT_ROLES.SUPER_ADMIN,
            TENANT_ROLES.CAMPUS_ADMIN,
            TENANT_ROLES.GUARDIAN,
            TENANT_ROLES.SECTION_TEACHER,
            TENANT_ROLES.PICKUP_PERSON,
          ],
        },
        {
          id: ROUTE.PICKUP_REQUEST_MANAGER.FACILITY_ALL_REQUESTS.ID,
          name: ROUTE.PICKUP_REQUEST_MANAGER.FACILITY_ALL_REQUESTS.NAME,
          route: { name: ROUTE.PICKUP_REQUEST_MANAGER.FACILITY_ALL_REQUESTS.PATH },
          role: [
            TENANT_ROLES.SUPER_ADMIN,
            TENANT_ROLES.CAMPUS_ADMIN,
            TENANT_ROLES.GUARDIAN,
            TENANT_ROLES.SECTION_TEACHER,
            TENANT_ROLES.PICKUP_PERSON,
          ],
        },
      ],
    },
    {
      id: ROUTE.ANNOUNCEMENTS.ID,
      name: ROUTE.ANNOUNCEMENTS.NAME,
      icon: ROUTE.ANNOUNCEMENTS.ICON,
      basedOn: [SCOPE_LEVELS.CAMPUS_LEVEL],
      role: [TENANT_ROLES.SUPER_ADMIN, TENANT_ROLES.CAMPUS_ADMIN],
      showChilds: false,
      routesName: [
        ROUTE.ANNOUNCEMENTS.TYPES.PATH,
        ROUTE.ANNOUNCEMENTS.VIEW.PATH,
        ROUTE.ANNOUNCEMENTS.DETAIL.PATH,
      ],
      childs: [
        {
          id: ROUTE.ANNOUNCEMENTS.TYPES.ID,
          name: ROUTE.ANNOUNCEMENTS.TYPES.NAME,
          route: { name: ROUTE.ANNOUNCEMENTS.TYPES.PATH },
        },
        {
          id: ROUTE.ANNOUNCEMENTS.VIEW.ID,
          name: ROUTE.ANNOUNCEMENTS.VIEW.NAME,
          route: { name: ROUTE.ANNOUNCEMENTS.VIEW.PATH },
        },
        {
          id: ROUTE.ANNOUNCEMENTS.DETAIL.ID,
          name: ROUTE.ANNOUNCEMENTS.DETAIL.NAME,
          route: { name: ROUTE.ANNOUNCEMENTS.DETAIL.PATH },
          isDynamicRoute: true,
        },
      ],
    },
    {
      id: ROUTE.REGISTRATION_PROCESS.ID,
      icon: ROUTE.REGISTRATION_PROCESS.ICON,
      name: ROUTE.REGISTRATION_PROCESS.NAME,
      basedOn: [SCOPE_LEVELS.CAMPUS_LEVEL],
      role: [TENANT_ROLES.SUPER_ADMIN, TENANT_ROLES.CAMPUS_ADMIN],
      showChilds: false,
      redirect: { name: ROUTE.REGISTRATION_PROCESS.REDIRECT },
      routesName: [
        ROUTE.REGISTRATION_PROCESS.REGISTRATION.PATH,
        ROUTE.REGISTRATION_PROCESS.FORM_GENERATOR.PATH,
      ],
      childs: [
        {
          id: ROUTE.REGISTRATION_PROCESS.REGISTRATION.ID,
          name: ROUTE.REGISTRATION_PROCESS.REGISTRATION.NAME,
          route: { name: ROUTE.REGISTRATION_PROCESS.REGISTRATION.PATH },
        },
        {
          id: ROUTE.REGISTRATION_PROCESS.FORM_GENERATOR.ID,
          name: ROUTE.REGISTRATION_PROCESS.FORM_GENERATOR.NAME,
          route: { name: ROUTE.REGISTRATION_PROCESS.FORM_GENERATOR.PATH },
        },
      ],
    },

    {
      id: ROUTE.SUPPORT_QUERY.ID,
      icon: ROUTE.SUPPORT_QUERY.ICON,
      name: ROUTE.SUPPORT_QUERY.NAME,
      basedOn: [SCOPE_LEVELS.CAMPUS_LEVEL],
      isGuardianActive: true,
      role: [
        TENANT_ROLES.SUPER_ADMIN,
        TENANT_ROLES.CAMPUS_ADMIN,
        TENANT_ROLES.SECTION_TEACHER,
        TENANT_ROLES.GUARDIAN,
      ],
      route: { name: ROUTE.SUPPORT_QUERY.SUPPORT_QUERY_TYPES.PATH },
      showChilds: false,
      routesName: [
        ROUTE.SUPPORT_QUERY.SUPPORT_QUERY_TYPES.PATH,
        ROUTE.SUPPORT_QUERY.SUPPORT_QUERY.PATH,
      ],
      childs: [
        {
          id: ROUTE.SUPPORT_QUERY.SUPPORT_QUERY_TYPES.ID,
          name: ROUTE.SUPPORT_QUERY.SUPPORT_QUERY_TYPES.NAME,
          route: { name: ROUTE.SUPPORT_QUERY.SUPPORT_QUERY_TYPES.PATH },
          role: [TENANT_ROLES.SUPER_ADMIN, TENANT_ROLES.CAMPUS_ADMIN, TENANT_ROLES.SECTION_TEACHER],
        },
        {
          id: ROUTE.SUPPORT_QUERY.SUPPORT_QUERY.ID,
          name: ROUTE.SUPPORT_QUERY.SUPPORT_QUERY.NAME,
          route: { name: ROUTE.SUPPORT_QUERY.SUPPORT_QUERY.PATH },
        },
      ],
    },
  ].filter(Boolean)
  return routes
}
